import React from 'react';
import Grade from '../graphics/Grade';
import styled from 'styled-components';

const MarkerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  font-size: 14px;
  background-size: cover;
  background-position: center;
  z-index: 10;
  transform: translate(-50%, -25%);
  transition: transform 0.3s;

  &:hover, &.active {
    transform: scale(1.2) translate(-50%, -25%);
  }
`;

const marker = (props) => {
  return (
    <MarkerStyled className={props.showBalloon ? 'active' : ''}>
      <Grade grade={props.grade} />
    </MarkerStyled>
  );
}

export default marker;


// WEBPACK FOOTER //
// ./src/components/Marker/index.js